import { render, staticRenderFns } from "./workCard.vue?vue&type=template&id=48fd677d&scoped=true&"
import script from "./workCard.vue?vue&type=script&lang=js&"
export * from "./workCard.vue?vue&type=script&lang=js&"
import style0 from "./workCard.vue?vue&type=style&index=0&id=48fd677d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fd677d",
  null
  
)

export default component.exports